/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
const n = (e, t) => e === t.length - 1, o = (e, t) => {
  const s = n(e, t);
  return e === 0 && !s ? "top" : s ? "bot" : "mid";
};
export {
  o as getNodePosition
};
